module.exports = __webpack_public_path__ + "img/keyboard_arrow_right-black-18dp.8b9c047f.svg";